<template>
  <div>
    <v-btn
      block
      class="primary rounded-pill my-4"
      @click.stop="dialogForm = true"
      ><v-icon class="mr-4">mdi-account-plus-outline</v-icon> Nouveau
      membre</v-btn
    >
    <v-dialog
      v-model="dialogForm"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="reset"> <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouveau membre de {{ groupe.nom_groupe }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="nom"
                    label="Nom"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="sexe" row :rules="selectRules">
                    <v-radio label="Masculin" value="1"></v-radio>
                    <v-radio label="Féminin" value="0"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="annee_naissance"
                    label="Année de naissance"
                    prepend-icon="person"
                    :rules="max4Rules"
                    required
                    type="number"
                    placeholder="1970"
                  ></v-text-field>
                </v-col>
                <template v-if="newMenage">
                  <v-col class="my-0" cols="12">
                    <v-btn
                      @click="newMenage = !newMenage"
                      dark=""
                      class="info rounded-pill"
                      block
                      >ménages existants</v-btn
                    >
                  </v-col>
                </template>
                <template v-else>
                  <v-col class="my-0" cols="12">
                    <v-autocomplete
                      v-model="code_menage"
                      dense
                      :items="MembresDuGroupe"
                      label="Ménage"
                      outlined
                      item-value="code_menage"
                      item-text="nom"
                      :rules="selectRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="my-0" cols="12">
                    <v-btn
                      @click="newMenage = !newMenage"
                      dark=""
                      class="info rounded-pill"
                      block
                      >Nouveau ménage</v-btn
                    >
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-btn class="rounded-pill neumorphic warning" @click="reset"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newLoading"
            @click="create"
            >Créer membre</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      newLoading: false,
      dialogForm: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      max4Rules: [
        (v) => !!v || "requis",
        (v) =>
          (v && v.length <= 4) ||
          "Vérifier l'année de naissance, 4 chiffres maximum",
      ],
      nom: "",
      annee_naissance: "",
      code_menage: "",
      sexe: "0",
      newMenage: true,
    };
  },
  props: {
    groupe: {
      type: Object,
      required: true,
    },
    id: {
      required: true,
    },
  },
  methods: {
    create() {
      let uuid = this.$uuid.v4();
      if (this.newMenage) {
        var code_menage = "MEN-" + uuid;
      } else {
        var code_menage = this.code_menage;
      }

      if (this.$refs.form.validate()) {
        let self = this;
        let listArray = [];
        this.groupe.projets.forEach(function (projet, index) {
          listArray[index] = projet.id_programme;
          listArray[index] = projet.id;
        });
        this.newLoading = true;

        let newMembre = {
          actif_dans_groupe: 1,
          id_groupe: this.id,
          membre_gec: 1,
          raison_inactivite: "",
          id_responsable: this.groupe.responsable,
          code_menage: code_menage,
          date_insert_membre: this.$moment(new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          annee_naissance: parseInt(this.annee_naissance),
          sexe: parseInt(this.sexe),
          nom_responsable: this.groupe.nom_responsable,
          nom: this.nom,
          village: this.groupe.village,
          nom_groupe: this.groupe.nom_groupe,
          ll_commune: this.groupe.ll_commune,
          ll_fokontany: this.groupe.ll_fokontany,
          id_commune: this.groupe.id_commune,
          ll_region: this.groupe.ll_region,
          id_district: this.groupe.id_district,
          id_region: this.groupe.id_region,
          ll_district: this.groupe.ll_district,
          code_fokontany: this.groupe.code_fokontany,
          projets: this.groupe.projets,
          projectList: listArray,
          id: uuid,
        };

        //console.log("insert  newMembre: ", newMembre);

        //insert  newMembre
        this.$firebase
          .firestore()
          .collection("membres")
          .doc(uuid)
          .set(newMembre, { merge: true });
        console.log("membre créé id: " + uuid);

        //vuex insert Membre
        this.addOneItem(newMembre);

        //ménage
        if (this.newMenage) {
          var objetMenage = { ...newMembre };
          objetMenage.nomMembrePrincipal = this.nom;
          delete objetMenage.actif_dans_groupe;
          delete objetMenage.annee_naissance;
          delete objetMenage.date_insert_membre;
          delete objetMenage.membre_gec;
          delete objetMenage.nom;
          delete objetMenage.raison_inactivite;
          delete objetMenage.sexe;
          objetMenage.dateGenerationMenage = self
            .$moment(Date.now())
            .format("YYYY-MM-DD HH:mm:ss");
          objetMenage.projectList = listArray;
          objetMenage.projets = this.groupe.projets;
          //code_menage
          objetMenage.id = code_menage;
          objetMenage.ll_menage = code_menage;

          // insert New Ménage
          console.log("insert New Ménage", objetMenage);

          this.$firebase
            .firestore()
            .collection("newMenages")
            .doc(code_menage)
            .set(objetMenage, { merge: true });
          console.log("ménage créé id:" + code_menage);
          //vuex insert newMenages
          this.addOneItemMenages(objetMenage);
        }

        this.GetMembresDuGroupe(this.id);

        this.reset();
      } else {
        console.log("veuillez valider d'abord");
      }
    },
    reset() {
      this.$refs.form.reset();
      this.communes = [];
      this.newLoading = false;
      this.dialogForm = false;
    },
    ...mapActions({
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      addOneItem: "Membres/addOneItem",
      addOneItemMenages: "Menages/addOneItem",
    }),
  },
  computed: {
    ...mapState({
      MembresDuGroupe: (state) => state.Membres.MembresDuGroupe,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
